import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class Company extends DomainObject {
  phoneNumber;
  employeeCount;
  name;
  locations = [
    {
      regionCode: 'ON',
      countryCode: 'CA',
      name: 'Head Office'
    }
  ];
  demoAccount;
  hqCaRegionCode;
  suggestedHqCaRegionCode;
  payrollEnabled;
  orgChartEnabled;
  jazzHRApiKey;
  greenhouseApiKey;
  bankingEnabled;
  showPTOCalendarType;

  constructor(other) {
    super();

    makeObservable(this, {
      phoneNumber: observable,
      employeeCount: observable,
      name: observable,
      locations: observable,
      demoAccount: observable,
      hqCaRegionCode: observable,
      suggestedHqCaRegionCode: observable,
      payrollEnabled: observable,
      orgChartEnabled: observable,
      jazzHRApiKey: observable,
      greenhouseApiKey: observable,
      bankingEnabled: observable,
      showPTOCalendarType: observable
    });

    this.merge(other);
  }
}

export default Company;
